import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "trash",
  "use": "trash-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"trash\"><path d=\"M7 8h1v7H7V8zM13 8h-1v7h1V8z\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15 5h3v1h-2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6H2V5h3V4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1zM5 6v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6H5zm9-1V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1h8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol